<div class="row justify-content-center">
  <div class="col-md-10">
    <div class="card card-secondary">
      <div class="card-header">
        <h4 class="card-title w-100">
          <span>Assistant Access</span>
        </h4>
      </div>
    </div>
    <div *ngIf="!profile.isAssisting">
      <div class="col-md-12">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="formheadertext text-justify">
              <p>
                You can designate one (or more) of your staff to have access to your portal account configuration,
                but from his/her own login. When your designee uses the Agent Portal "Assist Mode", anything they
                do will appear as if you did it yourself, therefore you are responsible for their actions and use
                of data under the confidentiality and data-protection provisions of your contract with Liberty Bankers
                Insurance Group. It is your responsibility to maintain this access - including modifying access dates
                or ending access entirely when your staff changes.
              </p>
              <p>
                Simply provide the user's email address (that they will establish their own login/account with) as well
                as access dates below; our system will automatically send them an invitation via email with key details.
                The invitation will mention the importance of acting in accordance with your contracted terms of use, but
                we appreciate you for personally reinforcing the criticality of protecting our client's data at all times.
              </p>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="showAddButton && !profile.isAssisting">
        <div class="text-center mb-4">
          <input type="button" class="btn btn-secondary input-block-level" value="Add Access" (click)="onAddClicked()">
        </div>
      </ng-container>
      <div class="row admin-box" *ngIf="showList">
        <div #gridWrapper class="col-md-12">
          <ag-grid-angular style="height: 300px;"
                           class="ag-theme-alpine"
                           [rowData]="invitations$ | async"
                           [columnDefs]="columnDefs"
                           [defaultColDef]="defaultColumnDef"
                           rowSelection='single'
                           [suppressRowClickSelection]="true"
                           (gridReady)="onGridReady($event)"
                           [overlayNoRowsTemplate]="noRowsTemplate"
                           (rowClicked)="onRowClicked($event)">
          </ag-grid-angular>
        </div>
      </div>
      <div class="card card-primary" id="InvitationDetails" *ngIf="showDetail">
        <div class="card-header">
          <div class="row">
            <div class="col-md-10">
              <h4 class="card-title w-100">
                <span>Invitation Detail</span>
              </h4>
            </div>
            <div class="col-md-2 my-auto text-right">
              <i class="fas fa-2x fa-times-circle" style="cursor:pointer" (click)="closeDetail()"></i>
            </div>
          </div>
        </div>
        <!--<ng-container *ngIf="showUpdateForm">
        <form #userAssistUpdateForm="ngForm" (ngSubmit)="updateInvitation(userAssistUpdateForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="selectedAssistUserEmail">User Assistant</label>
                  <input type="text" class="form-control" name="selectedAssistUserEmail" id="selectedAssistUserEmail" [(ngModel)]="selectedAssistUserEmail" readonly>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="assistUserStartDate">Start Date</label>
                  <input type="text" class="form-control date-slashes" name="assistUserStartDate" id="assistUserStartDate" placeholder="enter start date as mm/dd/yyyy" maxlength="10" [class.is-invalid]="startDateError"
                         [ngModel]="selectedAssistUserStartDate" (ngModelChange)="selectedAssistUserStartDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onStartDateBlur()">
                  <small *ngIf="startDateError" class="form-text text-danger">{{ startDateError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="assistUserEndDate">End Date</label>
                  <input type="text" class="form-control date-slashes" name="assistUserEndDate" id="assistUserEndDate" placeholder="leave blank for no end date" maxlength="10" [class.is-invalid]="endDateError"
                         [ngModel]="selectedAssistUserEndDate" (ngModelChange)="selectedAssistUserEndDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onEndDateBlur()">
                  <small *ngIf="endDateError" class="form-text text-danger">{{ endDateError }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <div *ngIf="updateErrorMessage" class="alert alert-danger" role="alert">
                {{ updateErrorMessage }}
              </div>
              <input type="submit" class="btn btn-secondary input-block-level" name="updateButton" id="updateButton" [value]="saving ? 'Saving…' : 'Update'" [disabled]="saving">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Delete" (click)="deleteInvitation()" [disabled]="saving">
            </div>
          </div>
        </form>
      </ng-container>-->
        <ng-container *ngIf="showUpdateForm">
          <form #userAssistUpdateForm="ngForm" (ngSubmit)="updateInvitation(userAssistUpdateForm)" novalidate>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="selectedAssistUserEmail">User Assistant</label>
                    <input type="text" class="form-control" name="selectedAssistUserEmail" id="selectedAssistUserEmail" [(ngModel)]="selectedAssistUserEmail" readonly>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="assistUserStartDate">Start Date</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="assistUserStartDate" id="assistUserStartDate"
                             placeholder="mm/dd/yyyy" maxlength="10" required
                             ngbDatepicker #updStartDp="ngbDatepicker" container="body"
                             [(ngModel)]="selectedAssistUserStartDate" #updStartCtrl="ngModel"
                             [class.is-invalid]="updStartCtrl.invalid && (updStartCtrl.dirty || updStartCtrl.touched)"
                             (focus)="inputFocused($event)">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" (click)="updStartDp.toggle()" [disabled]="saving" aria-label="Open start date calendar">
                          <i class="far fa-calendar-alt"></i>
                        </button>
                      </div>
                    </div>
                    <small *ngIf="updStartCtrl.errors?.required && (updStartCtrl.dirty || updStartCtrl.touched)" class="form-text text-danger">Enter the start date.</small>
                    <small *ngIf="updStartCtrl.errors?.ngbDate && (updStartCtrl.dirty || updStartCtrl.touched)" class="form-text text-danger">Enter the start date as mm/dd/yyyy.</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="assistUserEndDate">End Date</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="assistUserEndDate" id="assistUserEndDate"
                             placeholder="leave blank for no end date" maxlength="10"
                             ngbDatepicker #updEndDp="ngbDatepicker" container="body"
                             [(ngModel)]="selectedAssistUserEndDate" #updEndCtrl="ngModel"
                             [class.is-invalid]="updEndCtrl.invalid && (updEndCtrl.dirty || updEndCtrl.touched)"
                             (focus)="inputFocused($event)">
                      <div class="input-group-append">
                        <button *ngIf="updEndCtrl.value" class="btn btn-outline-secondary" type="button" (click)="clearEndDate(updEndCtrl)" [disabled]="saving" aria-label="Clear end date">
                          <i class="fas fa-times"></i>
                        </button>
                        <button class="btn btn-outline-secondary" type="button" (click)="updEndDp.toggle()" [disabled]="saving" aria-label="Open end date calendar">
                          <i class="far fa-calendar-alt"></i>
                        </button>
                      </div>
                    </div>
                    <small *ngIf="updEndCtrl.errors?.ngbDate && (updEndCtrl.dirty || updEndCtrl.touched)" class="form-text text-danger">Enter the end date as mm/dd/yyyy, or clear it for no end date.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="text-center">
                <div *ngIf="updateErrorMessage" class="alert alert-danger" role="alert">
                  {{ updateErrorMessage }}
                </div>
                <input type="submit" class="btn btn-secondary input-block-level" name="updateButton" id="updateButton" [value]="saving ? 'Saving…' : 'Update'" [disabled]="saving">&nbsp;&nbsp;&nbsp;
                <input type="button" class="btn btn-danger input-block-level" value="Suspend Access" (click)="suspendInvitation()" [disabled]="saving || isSuspended">
                <div *ngIf="isSuspended" class="mt-2">
                  <small class="form-text text-muted">Already suspended &mdash; this invitation ended {{ loadedEndDate | date:'MM/dd/yyyy' }}.</small>
                </div>
              </div>
            </div>
          </form>
        </ng-container>
        <!--<ng-container *ngIf="showAddForm">
        <form #userAssistAddForm="ngForm" (ngSubmit)="addInvitation(userAssistAddForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="addAssistUserEmail">User Assistant</label>
                  <input type="text" class="form-control" name="addAssistUserEmail" id="addAssistUserEmail" placeholder="enter email address" maxlength="254" required [class.is-invalid]="emailError"
                         [(ngModel)]="selectedAssistUserEmail" (blur)="onEmailBlur()">
                  <small *ngIf="emailError" class="form-text text-danger">{{ emailError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="addAssistUserStartDate">Start Date</label>
                  <input type="text" class="form-control date-slashes" name="addAssistUserStartDate" id="addAssistUserStartDate" placeholder="enter start date as mm/dd/yyyy" maxlength="10" [class.is-invalid]="startDateError"
                         [ngModel]="selectedAssistUserStartDate" (ngModelChange)="selectedAssistUserStartDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onStartDateBlur()">
                  <small *ngIf="startDateError" class="form-text text-danger">{{ startDateError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="addAssistUserEndDate">End Date</label>
                  <input type="text" class="form-control date-slashes" name="addAssistUserEndDate" id="addAssistUserEndDate" placeholder="leave blank for no end date" maxlength="10" [class.is-invalid]="endDateError"
                         [ngModel]="selectedAssistUserEndDate" (ngModelChange)="selectedAssistUserEndDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onEndDateBlur()">
                  <small *ngIf="endDateError" class="form-text text-danger">{{ endDateError }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div *ngIf="addErrorMessage" class="alert alert-danger" role="alert">
              {{ addErrorMessage }}
            </div>
            <div class="text-center">
              <input type="submit" class="btn btn-secondary input-block-level" name="addButton" id="addButton" value="Add" [disabled]="saving">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Reset" (click)="resetAddForm()">
            </div>
          </div>
        </form>
      </ng-container>-->
        <ng-container *ngIf="showAddForm">
          <form #userAssistAddForm="ngForm" (ngSubmit)="addInvitation(userAssistAddForm)" novalidate>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="addAssistUserEmail">User Assistant</label>
                    <input type="text" class="form-control" name="addAssistUserEmail" id="addAssistUserEmail" placeholder="enter email address" maxlength="254" required [class.is-invalid]="emailError"
                           [(ngModel)]="selectedAssistUserEmail" (blur)="onEmailBlur()">
                    <small *ngIf="emailError" class="form-text text-danger">{{ emailError }}</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="addAssistUserStartDate">Start Date</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="addAssistUserStartDate" id="addAssistUserStartDate"
                             placeholder="mm/dd/yyyy" maxlength="10" required
                             ngbDatepicker #addStartDp="ngbDatepicker" container="body"
                             [(ngModel)]="selectedAssistUserStartDate" #addStartCtrl="ngModel"
                             [class.is-invalid]="addStartCtrl.invalid && (addStartCtrl.dirty || addStartCtrl.touched)"
                             (focus)="inputFocused($event)">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" (click)="addStartDp.toggle()" [disabled]="saving" aria-label="Open start date calendar">
                          <i class="far fa-calendar-alt"></i>
                        </button>
                      </div>
                    </div>
                    <small *ngIf="addStartCtrl.errors?.required && (addStartCtrl.dirty || addStartCtrl.touched)" class="form-text text-danger">Enter the start date.</small>
                    <small *ngIf="addStartCtrl.errors?.ngbDate && (addStartCtrl.dirty || addStartCtrl.touched)" class="form-text text-danger">Enter the start date as mm/dd/yyyy.</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="addAssistUserEndDate">End Date</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="addAssistUserEndDate" id="addAssistUserEndDate"
                             placeholder="leave blank for no end date" maxlength="10"
                             ngbDatepicker #addEndDp="ngbDatepicker" container="body"
                             [(ngModel)]="selectedAssistUserEndDate" #addEndCtrl="ngModel"
                             [class.is-invalid]="addEndCtrl.invalid && (addEndCtrl.dirty || addEndCtrl.touched)"
                             (focus)="inputFocused($event)">
                      <div class="input-group-append">
                        <button *ngIf="addEndCtrl.value" class="btn btn-outline-secondary" type="button" (click)="clearEndDate(addEndCtrl)" [disabled]="saving" aria-label="Clear end date">
                          <i class="fas fa-times"></i>
                        </button>
                        <button class="btn btn-outline-secondary" type="button" (click)="addEndDp.toggle()" [disabled]="saving" aria-label="Open end date calendar">
                          <i class="far fa-calendar-alt"></i>
                        </button>
                      </div>
                    </div>
                    <small *ngIf="addEndCtrl.errors?.ngbDate && (addEndCtrl.dirty || addEndCtrl.touched)" class="form-text text-danger">Enter the end date as mm/dd/yyyy, or clear it for no end date.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div *ngIf="addErrorMessage" class="alert alert-danger" role="alert">
                {{ addErrorMessage }}
              </div>
              <div class="text-center">
                <input type="submit" class="btn btn-secondary input-block-level" name="addButton" id="addButton" value="Add" [disabled]="saving">&nbsp;&nbsp;&nbsp;
                <input type="button" class="btn btn-danger input-block-level" value="Reset" (click)="resetAddForm()">
              </div>
            </div>
          </form>
        </ng-container>
      </div>
    </div>
    <div *ngIf="profile.isAssisting">
      <div class="col-md-12">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="formheadertext text-center">
              <p>
                <strong>Feature not available while in Assist Mode.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
